/*
 * Copyright (c) 2023 Helvia Technologies PC <contact@helvia.io>
 */
import { useMutation } from "@tanstack/react-query";
import { refreshToken } from "./queryFunctions";

// import { tokens as Tokens } from "../../plugins/Tokens";
import { queryClient } from "@/utils/queryClient";

export const useRefreshToken = () => {
  // const tokensInstance = Tokens;
  return useMutation({
    mutationFn: refreshToken,
    onSuccess: (data) => {
      queryClient.setQueryData(['user-auth'], data);
    },
    onError() {
      queryClient.invalidateQueries({queryKey: ['user-auth']});
    },
    retry: 2
  });
};
